import { InitPWA } from './InitPWA';

export default InitPWA;
